import { useLocation } from 'react-router';

const ROUTES_WITH_NAVBAR = [
  /^\/brand\/[^/]+$/, // /brand/:brandId
  /^\/brand\/[^/]+\/overview$/, // /brand/:brandId/overview
  /^\/brand\/[^/]+\/manage$/, // /brand/:brandId/manage
  /^\/brand\/[^/]+\/audiences$/, // /brand/:brandId/audiences
  /^\/brand\/[^/]+\/custom-audiences$/, // /brand/:brandId/custom-audiences
  /^\/brand\/[^/]+\/custom-audiences\/new$/, // /brand/:brandId/custom-audiences/new
  /^\/brand\/[^/]+\/custom-audiences\/\d+$/, // /brand/:brandId/custom-audiences/:definitionId
  /^\/brand\/[^/]+\/agent$/, // /brand/:brandId/agent
  /^\/brand\/[^/]+\/insights/, // /brand/:brandId/insights/*
  /^\/brand\/[^/]+\/products$/, // /brand/:brandId/products
  /^\/brand\/[^/]+\/warnings$/, // /brand/:brandId/warnings
  /^\/brand\/[^/]+\/personas$/, // /brand/:brandId/personas
  /^\/brand\/[^/]+\/personas-form$/, // /brand/:brandId/personas-form
  /^\/brand\/[^/]+\/customer-overview$/, // /brand/:brandId/customer-overview
  /^\/brand\/[^/]+\/creative-engine$/, // /brand/:brandId/creative-engine
  /^\/brand\/[^/]+\/workflows$/, // /brand/:brandId/workflows
  /^\/profile$/,
  /^\/debug$/
];

const ROUTES_WITH_BLUEGREEN_BACKDROP = [
  '/email/verify',
  '/setup/user',
  '/setup/brand',
  '/setup/facebook',
  '/setup/ads'
];

const useShowNavbar = () => {
  const { pathname } = useLocation();
  const showNavbar = ROUTES_WITH_NAVBAR.some(pattern => pattern.test(pathname));
  const showBackdrop = ROUTES_WITH_BLUEGREEN_BACKDROP.includes(pathname);

  return {
    showNavbar,
    showBackdrop,
    ROUTES_WITH_NAVBAR,
    ROUTES_WITH_BLUEGREEN_BACKDROP
  };
};

export default useShowNavbar;
